import { render, staticRenderFns } from "./SsnInput.vue?vue&type=template&id=48a11a63&scoped=true&"
import script from "./SsnInput.vue?vue&type=script&lang=js&"
export * from "./SsnInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a11a63",
  null
  
)

export default component.exports